var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "layout" }, [
    _c("div", { staticClass: "layout__header" }, [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "layout__controls" }, [
        _c("div", { staticClass: "form-inline" }, [
          _c(
            "button",
            {
              staticClass: "btn-success btn--bigger",
              attrs: { type: "button" },
              on: { click: _vm.exportar }
            },
            [
              _c("i", { staticClass: "fa fa-file-excel-o" }),
              _vm._v(" "),
              _c("span", [_vm._v("Exportar")])
            ]
          )
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "card" }, [
      _c(
        "div",
        { staticClass: "card__content" },
        [
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-xs-12 col-md-3" }, [
              _c("div", { staticClass: "form-field select" }, [
                _c(
                  "div",
                  { staticClass: "select-field select-field--stretch" },
                  [
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.form.tipo_item,
                            expression: "form.tipo_item"
                          }
                        ],
                        attrs: { name: "tipo_item", id: "tipo_item" },
                        on: {
                          change: function($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function(o) {
                                return o.selected
                              })
                              .map(function(o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.$set(
                              _vm.form,
                              "tipo_item",
                              $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            )
                          }
                        }
                      },
                      [
                        _c("option", { attrs: { value: "T" } }, [
                          _vm._v("Todos")
                        ]),
                        _vm._v(" "),
                        _c("option", { attrs: { value: "P" } }, [
                          _vm._v("Productos")
                        ]),
                        _vm._v(" "),
                        _c("option", { attrs: { value: "S" } }, [
                          _vm._v("Servicios")
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c("label", { attrs: { for: "tipo_item" } }, [
                      _vm._v("Tipo")
                    ])
                  ]
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-xs-12 col-md-3" }, [
              _c(
                "div",
                { staticClass: "form-field select2 select2-field--stretch" },
                [
                  _c(
                    "div",
                    { staticClass: "select2-field" },
                    [
                      _c("v-select", {
                        attrs: {
                          placeholder: "Seleccione...",
                          id: "categoria",
                          options: _vm.categorias,
                          label: "nombre"
                        },
                        on: { input: _vm.inputCategoria },
                        model: {
                          value: _vm.selectedCategoria,
                          callback: function($$v) {
                            _vm.selectedCategoria = $$v
                          },
                          expression: "selectedCategoria"
                        }
                      }),
                      _vm._v(" "),
                      _c("label", { attrs: { for: "categoria" } }, [
                        _vm._v("Categoría")
                      ])
                    ],
                    1
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-xs-12 col-md-3" }, [
              _c(
                "div",
                { staticClass: "form-field select2 select2-field--stretch" },
                [
                  _c(
                    "div",
                    { staticClass: "select2-field" },
                    [
                      _c("v-select", {
                        attrs: {
                          placeholder: "Seleccione...",
                          id: "marca",
                          options: _vm.marcas,
                          label: "nombre"
                        },
                        on: { input: _vm.inputMarca },
                        model: {
                          value: _vm.selectedMarca,
                          callback: function($$v) {
                            _vm.selectedMarca = $$v
                          },
                          expression: "selectedMarca"
                        }
                      }),
                      _vm._v(" "),
                      _c("label", { attrs: { for: "marca" } }, [
                        _vm._v("Marca")
                      ])
                    ],
                    1
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-xs-12 col-md-3" }, [
              _c("div", { staticClass: "form-field select" }, [
                _c(
                  "div",
                  { staticClass: "select-field select-field--stretch" },
                  [
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.form.tipo,
                            expression: "form.tipo"
                          }
                        ],
                        attrs: { name: "tipo", id: "tipo" },
                        on: {
                          change: function($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function(o) {
                                return o.selected
                              })
                              .map(function(o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.$set(
                              _vm.form,
                              "tipo",
                              $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            )
                          }
                        }
                      },
                      [
                        _c("option", { attrs: { value: "E" } }, [
                          _vm._v("Ventas")
                        ]),
                        _vm._v(" "),
                        _c("option", { attrs: { value: "P" } }, [
                          _vm._v("Compras")
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c("label", { attrs: { for: "tipo" } }, [
                      _vm._v("Disponibilidad")
                    ])
                  ]
                )
              ])
            ])
          ]),
          _vm._v(" "),
          _c("k-table", {
            ref: "listaItems",
            attrs: {
              params: _vm.form,
              filterStatus: false,
              createButton: false,
              editButton: false,
              deleteButton: false,
              path: _vm.url + "/items/reportes",
              columns: [
                {
                  display: "Código",
                  value: "codigo"
                },
                {
                  display: "Tipo",
                  value: "descripcion_tipo_item"
                },
                {
                  display: "Categoría",
                  value: "descripcion_categoria"
                },
                {
                  display: "Nombre",
                  value: "nombre"
                },
                {
                  display: "Descripción",
                  value: "descripcion"
                },
                {
                  display: "Marca",
                  value: "descripcion_marca"
                },
                {
                  display: "Precio de venta",
                  value: "precio_venta"
                },
                {
                  display: "Subsidio",
                  value: "valor_subsidio"
                },
                {
                  display: "IVA",
                  value: "iva"
                },
                {
                  display: "ICE",
                  value: "ice"
                },
                {
                  display: "IRBPNR",
                  value: "descripcion_irbpnr"
                }
              ]
            }
          })
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "layout__title" }, [
      _c("h3", [_vm._v("Reporte de Ítems")])
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c7e0aad6", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c7e0aad6","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/reportes/ReporteItems.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-c7e0aad6","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/reportes/ReporteItems.vue
// module chunks = 0